import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  isPrinting = false

  constructor(private router: Router) {}
}
